import { observer } from 'mobx-react';
import { UserProductLicenseResource, licenseStatus } from '../../../../../ParticipantsStore/Types';
import { T } from '../../../../../Translations';

interface Props {
  license: UserProductLicenseResource;
}

function LicenseStatus({ license }: Props) {
  switch (licenseStatus(license)) {
    case 'Expired':
      return (
        <span className="bg-gray-700 text-xs rounded text-white py-1 px-2">
          <T kind="Expired" />
        </span>
      );
    case 'Allocated':
      return (
        <span className="bg-gray-400 text-xs rounded text-white py-1 px-2">
          <T kind="Allocated" />
        </span>
      );
    case 'Activated':
      return (
        <span className="bg-green-600 text-xs rounded text-white py-1 px-2">
          <T kind="Active" />
        </span>
      );
  }
}

export default observer(LicenseStatus);
